<template>
  <aside class="imagem-produto-dicas">
    <div class="imagem-produto-dicas-panel">
      <div class="imagem-produto-dicas-header mb-3">
        <v-icon color="primario" size="18" class="mr-2"
          >fas fa-lightbulb</v-icon
        >
        <span class="imagem-produto-dicas-title">Dicas importantes</span>
      </div>

      <v-card outlined class="imagem-produto-dica-card mb-3">
        <v-card-text class="py-3 px-3">
          <div class="d-flex align-start">
            <v-icon color="primario" size="20" class="mr-3 mt-1"
              >fas fa-crop-alt</v-icon
            >
            <div>
              <div class="imagem-produto-dica-card-titulo mb-1">
                Prefira imagens quadradas
              </div>
              <p class="imagem-produto-dica-card-text mb-0">
                Use imagens no formato quadrado, de preferência com fundo branco
                para um melhor resultado.
              </p>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <v-card outlined class="imagem-produto-dica-card">
        <v-card-text class="py-3 px-3">
          <div class="d-flex align-start">
            <v-icon color="primario" size="20" class="mr-3 mt-1"
              >far fa-images</v-icon
            >
            <div>
              <div class="imagem-produto-dica-card-titulo mb-1">
                Uma imagem principal sem numeração
              </div>
              <p class="imagem-produto-dica-card-text mb-0">
                Para cada produto, envie pelo menos uma imagem principal sem
                numeração, seguida das demais com numeração sequencial.
              </p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </aside>
</template>

<script>
export default {
  name: "ImagemProdutoDicas"
};
</script>

<style lang="scss" scoped>
.imagem-produto-dicas {
  height: 100%;
  min-height: 0;
  display: flex;
}

.imagem-produto-dicas-panel {
  height: 100%;
  width: 100%;
  padding: 14px;
  border-radius: 8px;
  background: rgba(25, 118, 210, 0.06);
  border: 1px solid rgba(25, 118, 210, 0.12);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.imagem-produto-dicas-header {
  display: flex;
  align-items: center;
}

.imagem-produto-dicas-title {
  font-size: 15px;
  font-weight: 600;
}

.imagem-produto-dica-card {
  border-radius: 8px !important;
  background: #fff;
}

.imagem-produto-dica-card-titulo {
  font-size: 13px;
  font-weight: 600;
}

.imagem-produto-dica-card-text {
  font-size: 12px;
  line-height: 1.5;
  opacity: 0.87;
}
</style>
